import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const parentingIraira: BlogMetaData = {
  title: '育児のイライラ解消法7選｜子育てのイライラが止まらない原因とモンテッソーリ流対処法',
  description:
    '「子育てイライラが止まらない…」原因は意志の弱さではありません。育児でイライラする5つの原因を整理し、モンテッソーリ教育の視点から今日から実践できるイライラ解消法7選を解説します。',
  thumbnailUrl: '/img/blog-parenting-iraira.webp',
  filePath: buildBlogFilePath('parenting-iraira'),
  category: BLOG_CATEGORY.PARENTING,
};
